import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// BANK WITHDRAWAL VERIFICATION
// Legacy: /AccountsApproval/VerifyBankWithdrawn (+ VerifyBankWithDrawnGrid / VerifyBankWithDrawnView /
// UpdateWithdrawnView)
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — withdrawals pending at this role's level (row carries MOID).
export const getVerificationWithdrawals = async (roleId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetWithdrawns`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail of one pending withdrawal (one-row list; adds AmountInWords).
export const getVerificationWithdrawalById = async (bankTranId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetVerificationwithdrawnbyId`, { params: { BankTranid: bankTranId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail of a returned withdrawal for the resubmit form (From = bank id).
export const getReturnedWithdrawalById = async (bankTranId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetReturnwithdrawbyId`, { params: { BankTranid: bankTranId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// "Withdrawal From" bank dropdown.
export const getBanks = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetBankDetails`, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Unused cheque numbers of a bank (by bank name) for Cheque mode.
export const getChequeNos = async (bankName) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetChequeNos`, { params: { bankname: bankName }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Return / Reject (spVerifyWithdrawn — success literal "Submitted").
export const verifyWithdrawal = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/Verifywithdraw`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Resubmit a returned withdrawal (SPGeneralBankPaymentupdateWithdraw — success literal "Successfull").
export const updateReturnedWithdrawal = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/Updatewithdraw`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
